import React, { useCallback, useState } from 'react'
import { Col, Row } from 'antd'
import { CloudUploadOutlined, LoadingOutlined } from '@ant-design/icons'
import { useDropzone } from 'react-dropzone'
import imageType from 'image-type'
import { getBase64Strings } from 'exif-rotate-js/lib'
import _ from 'lodash'
import withMobile from '../utils/isMobile'

function _arrayBufferToBase64(buffer) {
  let binary = ''
  const bytes = new Uint8Array(buffer)
  const len = bytes.byteLength
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i])
  }
  const { mime } = imageType(buffer)
  const compressedBase64 = `data:${mime};base64,${window.btoa(binary)}`
  return compressedBase64
}

const allowedMime = ['image/png', 'image/jpeg', 'image/jpg']

const ImageComponent = (props) => {
  const [settings, setSettings] = useState(false)
  return (
    <Col xs={8} sm={8} md={6} lg={6}>
      <div
        className="rounded relative w-full"
        onClick={() => setSettings(!settings)}
      >
        {settings && (
          <div className="text-white absolute top left w-full h-full flex items-center justify-center overlay rounded">
            <i
              className="material-icons text-4xl cursor-pointer"
              onClick={() => props.remove(props.index)}
            >
              delete_outline
            </i>
          </div>
        )}
        {props.src && (
          <img
            src={
              _.size(_.words(props.src, 'data:'), 'index') > 0
                ? props.src
                : `${process.env.REACT_APP_WEBSITE_PATH}/uploads/${props.src}`
            }
            className="object-cover rounded w-full h-32"
          />
        )}
        {!props.src && (
          <div className="h-32 flex w-full items-center justify-center">
            <LoadingOutlined
              style={{
                fontSize: 32,
              }}
            />
          </div>
        )}
      </div>
    </Col>
  )
}

const readFile = async (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onabort = () => console.log('file reading was aborted')
    reader.onerror = () => console.log('file reading has failed')
    reader.onload = async () => {
      // Do whatever you want with the file contents
      const binaryStr = reader.result
      const { mime } = imageType(binaryStr)
      if (_.includes(allowedMime, mime)) {
        resolve(_arrayBufferToBase64(binaryStr))
      } else {
        reject('Image type not allowed')
      }
    }
    reader.readAsArrayBuffer(file)
  })
}

const ImagesComponent = (props) => {
  const [files, setFiles] = useState(_.get(props.formValue, 'images', []))
  const [rejectedFiles, setRejectedFiles] = useState(0)
  props.loaderEnabled(true)
  const onDrop = useCallback(
    async (acceptedFiles) => {
      setRejectedFiles(0)
      const loadingFiles = [...files]
      _.each(acceptedFiles, (item) => loadingFiles.push(null))
      setFiles(loadingFiles)
      const tmpFiles = [...files]
      const base64Images = await getBase64Strings(acceptedFiles, {
        maxSize: 3600,
      })
      const newFiles = [...tmpFiles, ...base64Images]
      setFiles(newFiles)
      props.addValue({ images: newFiles })
      // props.form.setFieldsValue({images: newFiles})
    },
    [files]
  )
  const { getRootProps, getInputProps, open, acceptedFiles } = useDropzone({
    onDrop,
    accept: 'image/jpeg,image/jpg,image/png',
    noClick: true,
    noKeyboard: true,
  })

  const removeImage = (index) => {
    const _tmpFiles = [...files]
    _.remove(_tmpFiles, (file, i) => i === index)
    setFiles(_tmpFiles)
    props.addValue({ images: _tmpFiles })
    // props.form.setFieldsValue({images: _tmpFiles})
  }

  return (
    <>
      <div
        {...getRootProps({
          className:
            'rounded border border-gray-200 shadow-lg mb-5 py-24 flex w-full items-center justify-center',
        })}
      >
        <input {...getInputProps()} />
        <div className="flex flex-col items-center justify-center">
          <button
            type="button"
            onClick={open}
            className="uppercase bg-secondary rounded-full p-3 px-8 md:px-16 md:text-xl flex items-center w-auto outline-none mb-6"
          >
            <CloudUploadOutlined style={{ fontSize: 26 }} className="pr-2" />{' '}
            Carica Foto
          </button>
          {!props.isMobile && (
            <span className="md:text-xl text-gray-600">
              o trascina qui i tuoi file JPG/PNG
            </span>
          )}
        </div>
      </div>
      <div className="flex flex-wrap">
        <Row gutter={[8, 8]} className="w-full">
          {_.map(files, (file, index) => (
            <ImageComponent
              key={`image_upload_${index}`}
              src={_.get(file, 'visualizationImage', file)}
              index={index}
              remove={removeImage}
            />
          ))}
        </Row>
        {rejectedFiles > 0 && (
          <span className="text-red-500">
            Non e' stato possibile caricare alcune foto in quanto il formato non
            e' valido
          </span>
        )}
      </div>
    </>
  )
}

export default withMobile(ImagesComponent)
